export default __webpack_public_path__ + "static/Kalam-Light-9c1eab8b7236fc480fae9b2549237c04.woff";